<template>
  <PaymentDashboardMessage>
    <template #icon>
      <img src="../../../assets/img/account/plan/quota-message.svg" alt="">
    </template>
    <template #title>
      {{ $t('exceed') }}
    </template>
    <template #subtitle>
      {{ $t('variants') }}:
    </template>
    <template #items>
      <PaymentDashboardMessageItem>
        <template #left>
          {{ $t('upgrade') }}
        </template>
        <template #right>
          <VBtn color="success" @click="changePlan">
            {{ $t('choose') }}
          </VBtn>
        </template>
      </PaymentDashboardMessageItem>
      <PaymentDashboardMessageItem>
        <template #left>
          {{ $t('wait') }} ({{ endPeriodText }})
        </template>
        <template #right>
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M11.99 2C6.47 2 2 6.48 2 12C2 17.52 6.47 22 11.99 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 11.99 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20Z" fill="black" />
            <path d="M12.5 7H11V13L16.25 16.15L17 14.92L12.5 12.25V7Z" fill="black" />
          </svg>
          {{ $t('leftDays') }}: {{ leftDays }}
        </template>
      </PaymentDashboardMessageItem>
    </template>
  </PaymentDashboardMessage>
</template>

<script>
import useAccount from '@/compositions/accounting/useAccount';
import { paymentTabs, settingsTabs } from '@/enums';
import PaymentDashboardMessage from '@/components/Payment/Dashboard/PaymentDashboardMessage';
import PaymentDashboardMessageItem from '@/components/Payment/Dashboard/PaymentDashboardMessageItem';

export default {
  name: 'InterviewsQuotaExceeded',
  components: { PaymentDashboardMessageItem, PaymentDashboardMessage },
  setup(_, { root: { $router } }) {
    const { endPeriodText, leftDays } = useAccount();

    function changePlan() {
      $router.push({ name: 'settings', params: { type: settingsTabs.PAYMENT, addType: paymentTabs.PLANS } });
    }

    return {
      endPeriodText,
      leftDays,
      changePlan,
    };
  },
};
</script>

<style lang="scss" scoped>
.quota-message {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 0, 0, 0.2);
  border-radius: 0.25rem;
  padding: 0.75rem 1.5625rem 0.125rem 1.5625rem;
  font-size: 0.875rem;
  line-height: 1.43;
  margin-top: 1.75rem;
  &__top {
    display: flex;
    align-items: center;
    margin-bottom: 0.625rem;
  }
  &__top-image-wrap {
    display: flex;
    justify-content: center;
    align-items: center;
    min-width: 3rem;
    width: 3rem;
    height: 3rem;
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 50%;
    margin-right: 0.9375rem;
  }
  &__head {
    font-size: 1rem;
    line-height: 1.25;
    font-weight: 600;
    margin-bottom: 0.25rem;
  }
  &__item {
    display: flex;
    width: 100%;
    padding: 0.8125rem 0;
    border-top: 1px solid rgba(0, 0, 0, 0.1);
  }
  &__item-left-wrap {
    flex-grow: 1;
  }
  &__item-right-wrap {
    width: 10.625rem;
    margin-left: 1.25rem;
    flex-shrink: 0;
    text-align: right;
    svg {
      vertical-align: middle;
      margin-right: 0.25rem;
    }
  }
}
@media #{map-get($display-breakpoints, 'xs-only')} {
  .quota-message {
    &__item-right-wrap {
      margin-bottom: 0.75rem;
    }
    &__item {
      display: block;
    }
  }
}

</style>

<i18n lang="yml" locale="ru">
  exceed: У вас закончились просмотры откликов
  variants: Варианты
  leftDays: Осталось дней
  wait: Подождать до начала следующего отчётного периода
  choose: Выбрать тариф
  upgrade: Перейти на более высокий тариф и посмотреть новые отклики прямо сейчас.
</i18n>
<i18n lang="yml" locale="en">
  exceed: You have exceeded the number of interviews in your plan
  variants: You can
  leftDays: Days left
  wait: Wait for the next period to start
  choose: Choose plan
  upgrade: Upgrade your plan and see new applicants right now.
</i18n>
